// extracted by css-extract-rspack-plugin
export default {"emote":"LseXxm"};